<template>
  <fieldset v-if="mainConfig.showCustomerTerms" class="mb-4">
    <slot></slot>
  </fieldset>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "CustomerTerms",
  computed: {
    ...mapState(['mainConfig'])
  }
}
</script>

<style scoped>

</style>
